import { VersandSpesen } from '@/types/service-response'

export class ProjectBookingBelegVersandSpesen {
  public constructor (
    readonly Adresse: string | null,
    readonly AdressID: number | null,
    readonly VersandartId: number,
    readonly Spesen: string | null, //double
    readonly VersandKontoId: number
  ) {}

  static createFromResponse (responseData: VersandSpesen): ProjectBookingBelegVersandSpesen {
      return new ProjectBookingBelegVersandSpesen(
        responseData.Adresse,
        responseData.AdressID,
        responseData.VersandartId,
        responseData.Spesen !== null ? responseData.Spesen.toFixed(2) : null,
        responseData.VersandKontoId
      )
  }
}
